<template>
  <section id="main-wrap" class="pure-g">
  </section>
</template>

<script>
  import db from './firebaseInit'
  import firebase from 'firebase'

  export default {
    name: 'adminupdatedata',
    data () {
      return {
        grapes: [],
        grapevines: []
      }
    },
    created () {
      // this.migrateGrapevines()
    },
    computed: {
    },
    methods: {
      generateUUID () {
        let d = new Date().getTime()
        let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          let r = (d + Math.random() * 16) % 16 | 0
          d = Math.floor(d / 16)
          return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16)
        })
        return uuid
      },
      migrateGrapevines () {
        var grapevinesRef = firebase.database().ref('grapevines')
        grapevinesRef.once('value').then(function (snapshot) {
          snapshot.forEach(function (childSnapshot) {
            let grapevine = childSnapshot.val() // this is the user's data
            console.log(grapevine)
            db.collection('grapevines').add(grapevine)
          })
        })
      }
    }
  }
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/MigrateData.vue